import type { PipelineRun } from "../lib/api";

const statusClassName: Record<PipelineRun["status"], string> = {
  RUNNING: "border-info/25 bg-info/10 text-info",
  DONE: "border-primary/25 bg-primary/10 text-primary",
  SKIPPED: "border-warning/35 bg-warning/15 text-amber-800",
  FAILED: "border-danger/25 bg-danger/10 text-danger",
};

const statusLabel: Record<PipelineRun["status"], string> = {
  RUNNING: "В работе",
  DONE: "Готово",
  SKIPPED: "Пропущено",
  FAILED: "Ошибка",
};

export function StatusBadge({ status }: { status: PipelineRun["status"] }) {
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${statusClassName[status]}`}>
      {statusLabel[status]}
    </span>
  );
}

export function EventLevelBadge({ level }: { level: "INFO" | "WARN" | "ERROR" }) {
  const className =
    level === "ERROR"
      ? "border-danger/25 bg-danger/10 text-danger"
      : level === "WARN"
        ? "border-warning/35 bg-warning/15 text-amber-800"
        : "border-primary/20 bg-primary/10 text-primary";

  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${className}`}>
      {level}
    </span>
  );
}
